<div class="left-side" [style.background-color]="'#' + activity.type.color" (click)="openProject(activity.project.id)">
  <ng-content></ng-content>
  {{activity.type.shortCode}}
</div>
<div class="middle-side" (click)="openProject(activity.project.id)">
  <div class="project-name route-text-line">
    <span>{{activity.project?.name}}</span>
  </div>
  <div class="project-location route-text-line">
    {{activity.project?.location}}
  </div>
  <div class="project-location route-text-line" *ngIf="activity.deliveryInstructions">
    <i class="pi pi-exclamation-triangle"
       style="font-size: 100%; color: #ff9f1a;"></i> {{activity.deliveryInstructions}}
  </div>
  <div class="project-location route-tags" *ngIf="activity.isWorkOnSite">
    <span class="activity-route-tag">Site Work</span>
  </div>
</div>
<div class="checkmark-block">

<span class="delivery-duration"
      *ngIf="activity.deliveryDuration > 0 && inVehicle">{{getDuration(activity.deliveryDuration)}}</span>

  <p-checkbox [(ngModel)]="activity.ready" [binary]="true" [ngClass]="{'ready-checkbox': activity.ready}"
              inputId="binary" (onChange)="toggleActivity($event)"></p-checkbox>
</div>

